module.exports = __webpack_public_path__ + "static/media/img5.1d75cf77.jpg";